import { createPageElement } from "@modules/content/creators/createPageElement";
import { ContentPage } from "@modules/content/types";

export interface PodcastHubDetailsParameters {
  image: string | null;
  skillIcon: string | null;
}

export const PodcastHubDetails = createPageElement(
  ({ pageId, context }, ref) => {
    return (
      <div className="flex h-full items-center justify-center">
        <img
          src="/assets/images/coming-soon.png"
          alt="coming soon"
          className="h-[194px] w-[500px]"
        />
      </div>
    );
  }
);

export const PodcastHubDetailsPage: ContentPage = {
  identifier: "PG:PODCASTHUB:DETAILS",
  page: PodcastHubDetails,
};
